import React from 'react'
import { InstitutionLogo } from '@mxenabled/mxui'

import type { Beat } from '../../core/types/Beat'

export const InstitutionLogoIcon: React.FC<{ beat: Beat }> = ({ beat }) => (
  <InstitutionLogo alt={beat.institutionName || ''} institutionGuid={beat.institutionGuid || ''} />
)
